import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// NOTE: getAnalytics removed — it was causing 403 PERMISSION_DENIED
// and blocking Firestore with "client is offline" errors.
// Analytics requires Firebase Installations API to be enabled in GCP Console.
// You can re-enable it later from: console.cloud.google.com → APIs → Firebase Installations API

const firebaseConfig = {
  apiKey:            "AIzaSyCnsdD2s3I9U-mYShll44DWX9klVX2hntY",
  authDomain:        "quickchapaaupgraded.firebaseapp.com",  // must match actual project ID
  projectId:         "quickchapaaupgraded",
  storageBucket:     "quickchapaaupgraded.firebasestorage.app",
  messagingSenderId: "923842713961",
  appId:             "1:923842713961:web:96945771683a0dd28085f8",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;
